module.exports = __webpack_public_path__ + "img/ranktop_icon01.2e35c2c3.png";